import React from 'react';

import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { JobDetailsContainerStyled } from './style';

const TechnicalNote = ({ notes }: { notes: string }) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title"
        fontColor="secondary"
        strong
      >
        TECHNICIAN NOTE{' '}
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <div style={{ display: 'block' }}>
            <Typography className="title">Notes :</Typography>
            <Typography className="value">{notes}</Typography>
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};

export default TechnicalNote;
